import { formatReviewPeriod, type ReviewWindow } from "./helpers";
import { useText } from "./text";

const MAX_NAMES = 5;

export const ReviewWindowSummary = ({
  reviewWindow,
  statusLabel,
}: {
  reviewWindow: ReviewWindow;
  statusLabel: string;
}) => {
  const text = useText();
  const { documentReviews } = reviewWindow;
  const hiddenCount = documentReviews.length - MAX_NAMES;

  return (
    <div className="flex flex-col gap-1">
      <div className="text-muted-foreground">
        {`${formatReviewPeriod(reviewWindow)} · ${statusLabel}`}
      </div>
      <div className="text-sm font-semibold">
        {text.documents(documentReviews.length)}
      </div>
      <ul>
        {documentReviews.slice(0, MAX_NAMES).map(({ entry }) => (
          <li key={entry.id}>{entry.name}</li>
        ))}
      </ul>
      {hiddenCount > 0 && (
        <div className="text-muted-foreground">{text.andMore(hiddenCount)}</div>
      )}
    </div>
  );
};
